<!-- PAGINATION -->
@if (pager && pager.totalItems > pager.pageSize) {
  <nav class="paginator-wrapper" aria-label="Pagination">
    @if (pager.pages && pager.pages.length) {
      <ul class="pagination">
        @if (pager.currentPage !== 1) {
          <li class="page-item previous-item">
            <a href="#" (click)="changePage(pager.currentPage - 1, $event)" class="page-link">
              <i class="material-icons">arrow_back_ios</i>
            </a>
          </li>
        }
        @if (!pager.pages.includes(1)) {
          <li class="page-item first-item">
            <a href="#" (click)="changePage(1, $event)" class="page-link">1</a>
          </li>
        }
        @if (pager.pages[0] > 2) {
          <li>...</li>
        }
        @for (page of pager.pages; track page) {
          <li class="page-item number-item">
            <a href="#"
              [ngClass]="{active:pager.currentPage === page}"
              (click)="changePage(page, $event)"
              [attr.aria-label]="'Page ' + page"
              [attr.aria-current]="pager.currentPage === page"
              class="page-link">
              {{page}}
            </a>
          </li>
        }
        @if (pager.pages[pager.pages.length - 1] + 1 < pager.totalPages) {
          <li>...</li>
        }
        @if (!pager.pages.includes(pager.totalPages)) {
          <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}"
            class="page-item last-item">
            <a href="#" (click)="changePage(pager.totalPages, $event)" class="page-link">{{pager.totalPages}}</a>
          </li>
        }
        @if (pager.currentPage !== pager.totalPages) {
          <li class="page-item next-item">
            <a href="#" (click)="changePage(pager.currentPage + 1, $event)" class="page-link">
              <i class="material-icons">arrow_forward_ios</i>
            </a>
          </li>
        }
      </ul>
    }
  </nav>
}
<div #paginationDetails class="paginationDetails">
  <div class="weaveGrid splitGrid">
    <div class="paginator-results">Results {{pager.pageSize * (pager.currentPage - 1) + 1}}
      -{{pager.totalItems <= pager.pageSize ? pager.totalItems : pager.pageSize * pager.currentPage}}
    of {{pager.totalItems}}</div>

    <div #paginatorSize class="filterSelect" [ngClass]="{'open': pageSizeOpen}">
      <div class="itemFilters" [ngClass]="{'above' : pageSizePositionAboveDropdown}"
        (keyup.space)="togglePageSizeOpen()"
        role="button" tabindex="0" [attr.aria-label]="'change the items per page'">
        {{pager.pageSize}} / Page
        @if (!pageSizeOpen) {
          <span class="material-icons itemFiltersIcon">
            arrow_drop_down
          </span>
        }
        @if (pageSizeOpen) {
          <span class="material-icons">
            arrow_drop_up
          </span>
        }
      </div>
      @if (pageSizeOpen) {
        <div class="filter_options" [ngClass]="{'above' : pageSizePositionAboveDropdown}"
          (keydown.escape)="togglePageSizeOpen()">
          <ul>
            @for (item of pageSizes; track item; let i = $index) {
              <li
              [ngClass]="{
                        'current': item.checked
                      }"
                >
                <button (click)="changePageSize(item)">{{item.label}}</button>
              </li>
            }
          </ul>
        </div>
      }
    </div>

  </div>
</div>
